export default __webpack_public_path__ + "static/media/Astronaut_05.0c374fce.png";